const scripts = {}
const debug = false

export const GOOGLE_MAPS = {
  expectedGlobal: 'google',
  timeout: 4000,
  url: 'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyAeaMGYf_AdO4VwcddUyCWoPxf7pzvfXd8'
}

export const FACEBOOK_SDK = {
  expectedGlobal: 'FB',
  timeout: 3000,
  url: 'https://connect.facebook.net/en_US/sdk.js'
}

const isPromise = item => typeof item === 'object' && typeof item.then === 'function'

export default async function LoadScript({ url, expectedGlobal, timeout=2000 } = {}) {

  // Dedupe requests in flight
  if (isPromise(scripts[url])) {
    debug && console.log(`[Script Loader] currently in progress loading ${url}, deduping...`)
    return scripts[url]
  }

  // Immediately resolve if previously reloaded
  if (scripts[url] === true) {
    debug && console.log(`[Script Loader] already loaded ${url}`)
    return Promise.resolve()
  }


  // Guard against loading a script multiple times even if it was loaded in a different method
  if (expectedGlobal && window[expectedGlobal]) {
    console.warn(`[Script Loader] no record of loading ${url}, but window.${expectedGlobal} already exists`)
    scripts[url] = true
    return Promise.resolve()
  }

  // Fetch script if necessary
  let promise = download(url)
  scripts[url] = promise
  debug && console.log(`[Script Loader] downloading ${url}...`)
  let loadingScriptPromise = promise
    // Clean up promise if success
    .then(() => {
      scripts[url] = true
      debug && console.log(`[Script Loader] loaded ${url}!`)
    })

    // Clean up promise if error, but bubble afterwards
    .catch(err => {
      debug && console.error(`[Script Loader] failed to load ${url}`, err)
      delete scripts[url]
      throw err
    })

    // Load script, but reject early according to the timeout
    return Promise.race([
      loadingScriptPromise,
      failAfter(timeout, `[Script Loader] failed to load ${url} after ${timeout}ms`)
    ])
}


async function download(url) {
  return new Promise((resolve, reject) => {
      let newScript = document.createElement('script')
      newScript.src = url
      newScript.async = true
      newScript.defer = true
      newScript.onload = resolve
      newScript.onerror = reject
      document.body.appendChild(newScript)
  })
}


async function failAfter(ms, message) {
  return new Promise((resolve, reject) => {
    setTimeout(() => reject(message), ms)
  })
}
